<template>
  <q-card style="min-width: 400px">
    <q-card-section>
      <div class="text-h6">类型</div>
    </q-card-section>
    <q-card-section class="q-pt-none">
      <q-option-group v-model="type" :options="typeOptions" inline />
    </q-card-section>

    <q-card-section>
      <div class="text-h6">内容</div>
    </q-card-section>
    <q-card-section class="q-pt-none">
      <q-input dense v-model="message" autofocus @keydown.enter="show()" />
    </q-card-section>

    <q-card-actions>
      <i-btn icon="cancel" color="action-cancel" label="取消" v-close-popup />
      <q-space />
      <i-btn icon="done" color="action-ok" label="确定" @click="show()" v-close-popup />
    </q-card-actions>
  </q-card>
</template>

<script>
export default {
  data () {
    return {
      typeOptions: [
        { value: 'info', label: 'Info' },
        { value: 'warning', label: 'Warn' },
        { value: 'negative', label: 'Error' },
        { value: 'positive', label: 'Ok' }
      ],
      type: null,
      message: null
    }
  },
  mounted () {
    this.reset()
  },
  methods: {
    reset () {
      this.type = 'info'
      this.message = null
    },
    show () {
      if (this.message) {
        this.$q.notify({
          type: this.type,
          message: this.message
        })
      }
    }
  }
}
</script>
